import React from 'react';

interface BadgeProps {
    number: number;
    icon: any
}

const CustomBadge: React.FC<BadgeProps> = ({ number, icon }) => {
    return (
        <div className={'grid w-[22px] h-[22px]'}>
            <span className={'ml-[9px] mt-[4px]'}>
                {icon}
            </span>
            {number > 0 &&
                <div className="badge">
                    <div className="badge-number">{number}</div>
                </div>
            }
        </div>
    );
};

export default CustomBadge;
